import { render, staticRenderFns } from "./DateFromNow.vue?vue&type=template&id=c05cd300"
import script from "./DateFromNow.vue?vue&type=script&lang=js"
export * from "./DateFromNow.vue?vue&type=script&lang=js"
import style0 from "./DateFromNow.vue?vue&type=style&index=0&id=c05cd300&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports